"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _helpers = require("../../../utils/helpers");

var _Button = _interopRequireDefault(require("../../Button"));

var _Navigation = _interopRequireDefault(require("../../Navigation"));

var _NavigationList = _interopRequireDefault(require("../../Navigation/NavigationList"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Layout = require("../../Layout");

var _Typography = require("../../Typography");

var _hooks = require("../../../utils/hooks");

var _HeaderPrimary = require("./HeaderPrimary.style");

var HeaderPrimary = function HeaderPrimary(_ref) {
  var active = _ref.active,
      closeNav = _ref.closeNav,
      cta = _ref.cta,
      handleOpenNav = _ref.handleOpenNav,
      homeLink = _ref.homeLink,
      isLargeNav = _ref.isLargeNav,
      isNavOpen = _ref.isNavOpen,
      links = _ref.links,
      logoImage = _ref.logoImage,
      place = _ref.place;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      slug = _ref2.slug,
      header = _ref2.header,
      colors = _ref2.colors,
      name = _ref2.name,
      space = _ref2.space;

  var isMobileNav = !isLargeNav;
  var Logo = (0, _helpers.getLogo)(slug);
  var hasMounted = (0, _hooks.useHasMounted)();
  var dropdownProps = {
    onClick: handleOpenNav,
    isNavOpen: isNavOpen
  };
  var iconProps = {
    color: isNavOpen ? colors.greydark : colors[header.primary.foreground],
    size: '28px',
    ml: space.small,
    transform: isNavOpen ? 'rotate(180deg)' : 'rotate(0deg)'
  };
  var navigationProps = {
    links: links,
    active: active,
    variant: 'primary'
  };
  var logoProps = logoImage ? _objectSpread(_objectSpread({}, logoImage), {}, {
    height: header.logo.height,
    src: logoImage.fluid ? logoImage.fluid.src : logoImage.src
  }) : {
    color: colors[header.logo.color],
    height: header.logo.height,
    width: header.logo.width
  };

  var buttonProps = _objectSpread({
    variant: isLargeNav ? header.primary.button : 'primary',
    width: isLargeNav ? 'auto' : '100%'
  }, cta);

  var naviagtionListProps = {
    links: links,
    active: active,
    isNavOpen: isNavOpen,
    closeNav: closeNav,
    isLargeNav: isLargeNav,
    place: place
  };
  return /*#__PURE__*/_react.default.createElement(_HeaderPrimary.Wrapper, null, /*#__PURE__*/_react.default.createElement(_HeaderPrimary.HeaderContainer, null, /*#__PURE__*/_react.default.createElement(_HeaderPrimary.LogoLink, {
    to: homeLink,
    onClick: closeNav
  }, logoImage ? /*#__PURE__*/_react.default.createElement(_HeaderPrimary.LogoImage, logoProps) : /*#__PURE__*/_react.default.createElement(Logo, logoProps), /*#__PURE__*/_react.default.createElement(_Typography.HiddenText, null, name, " Logo")), hasMounted && links.length > 0 && /*#__PURE__*/_react.default.createElement(_HeaderPrimary.NavWrapper, null, isMobileNav && /*#__PURE__*/_react.default.createElement(_HeaderPrimary.Dropdown, dropdownProps, /*#__PURE__*/_react.default.createElement(_HeaderPrimary.DropdownText, {
    isNavOpen: isNavOpen
  }, "Menu"), /*#__PURE__*/_react.default.createElement(_Icon.default, Object.assign({
    name: "ChevronDown"
  }, iconProps))), isLargeNav && /*#__PURE__*/_react.default.createElement(_Navigation.default, navigationProps)), isLargeNav && cta && /*#__PURE__*/_react.default.createElement(_Button.default, buttonProps, cta.label)), links.length > 0 && isMobileNav && /*#__PURE__*/_react.default.createElement(_HeaderPrimary.DropdownWrapper, {
    isNavOpen: isNavOpen
  }, cta && /*#__PURE__*/_react.default.createElement(_Layout.Container, {
    py: space.base
  }, /*#__PURE__*/_react.default.createElement(_Button.default, buttonProps, cta.label)), links && /*#__PURE__*/_react.default.createElement(_NavigationList.default, naviagtionListProps)));
};

HeaderPrimary.propTypes = {
  active: _propTypes.default.string,
  closeNav: _propTypes.default.func.isRequired,
  cta: _propTypes.default.shape(Object),
  handleOpenNav: _propTypes.default.func.isRequired,
  homeLink: _propTypes.default.string,
  isLargeNav: _propTypes.default.bool.isRequired,
  isNavOpen: _propTypes.default.bool,
  links: _propTypes.default.arrayOf(Object),
  logoImage: _propTypes.default.shape(Object),
  place: _propTypes.default.oneOf(['legacyHeader', 'header'])
};
HeaderPrimary.defaultProps = {
  active: '',
  cta: null,
  homeLink: '/',
  isNavOpen: false,
  links: [],
  logoImage: null,
  place: 'legacyHeader'
};
var _default = HeaderPrimary;
exports.default = _default;